import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockSettings, { BlockAlign, BlockHeight, BlockJustify } from '../../../models/BlockSettings';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockTitleTextButtonData {
  title?: BlockComponentText;
  description?: BlockComponentText;
  button?: BlockComponentButton;
  settings?: BlockSettings;
  url?: BlockComponentImage;
  height?: BlockHeight;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTitleTextButtonData {
  export function make(height: BlockHeight, title?: string, description?: string, button?: BlockComponentButton, settings?: BlockSettings, url?: string): BlockTitleTextButtonData {
    return {
      height,
      title: title ? BlockComponentText.make(title) : undefined,
      description: description ? BlockComponentText.make(description) : undefined,
      button: BlockComponentButton.make(button.link, button.settings),
      settings: BlockSettings.make(settings.align, settings.justify),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(
    height = BlockHeight.NORMAL,
    alignment = BlockAlign.CENTER,
    title = 'タイトル',
    description = 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト。',
    imageUrl?: string,
  ): BlockTitleTextButtonData {
    return make(
      height,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      `<p>${description}</p>`,
      BlockComponentButton.getDefault(),
      BlockSettings.getDefault(alignment, BlockJustify.CENTER),
      imageUrl,
    );
  }
}

export default BlockTitleTextButtonData;
